<template>
  <information-table
      :fields="fields"
      :items="topics"
      @deleteItem="deleteItem"
      @editItem="editItem"/>
</template>

<script>
import InformationTable from "@/components/InformationTable";

export default {
  name: "topics",
  components: {InformationTable},
  props: {
    topics: Array,
    fields: Array
  },
  methods: {
    deleteItem(value) {
      this.$emit("deleteItem", value)
    },
    editItem(value) {
      this.$emit("editItem", value)
    }
  }
}
</script>
